<template>
  <div>
    <div class="s-img">
      <img src="@/assets/images/news/16-1_02.jpg" />
    </div>
    <div class="s-swiper">
      <swiper ref="swiper" :options="swiperOption">
        <swiper-slide
          class="swiper-item"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="swiper-cell">
            <div class="swiper-img">
              <img :src="item.url" />
            </div>
            <div class="swiper-h">
              <div class="swiper-l">
                {{ item.num > 9 ? item.num : "0" + item.num }}
              </div>
              <div class="swiper-r">{{ item.title }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="s-box">
      <!-- <div class="s-title">
        <img src="@/assets/images/news/title.jpg" />
      </div> -->
      <!-- 新闻动态区域 -->
      <div class="news-title-section">
        <div class="title-line"></div>
        <div class="title-content">
          <div class="main-title">新闻动态</div>
          <div class="sub-title">ALL NEWS</div>
        </div>
        <div class="title-line"></div>
      </div>
      <div class="s-ul">
        <div class="s-li" v-for="(item, index) in newsList" :key="index">
          <div
            :class="['s-cell', item.isSet]"
            @mouseenter="handleMouseOver(index)"
            @mouseleave="outMouseOver(index)"
          >
            <div class="l-left">
              <img :src="item.url" />
            </div>
            <div class="l-right">
              <div class="l-h">
                <b>0{{ item.num }}.</b>
                <font style="font-weight: bold">{{ item.title }}</font>
              </div>
              <div class="l-world">
                <div class="l-text">{{ item.describe }}</div>
                <div class="l-btn-box">
                  <div class="l-btn-l" @click.stop="goDetail(index)">
                    <font>了解详情</font>
                  </div>
                  <div class="l-btn-r">
                    <font>{{ item.time }}</font>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ============翻页功能====== -->
      <div class="page-box" v-if="pageNum > 0">
        <div class="page-ul">
          <div class="page-li">
            <div
              class="page-cell"
              style="font-size: 0.9rem"
              @click="goFlipping(1)"
            >
              上一页
            </div>
          </div>
          <div class="page-li" v-for="(item, index) in pageList" :key="index">
            <div :class="['page-cell', item.isSet]" @click="setPage(index)">
              <font>{{ item.num }}</font>
            </div>
          </div>
          <div class="page-li">
            <div
              class="page-cell"
              style="font-size: 0.9rem"
              @click="goFlipping(2)"
            >
              下一页
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import axios from "axios";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      pageIndex: 1,
      pageNum: 0,
      pageList: [], //分页列表
      // =================
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: 1, //页面中的板块数量
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      newsList: [],
    };
  },
  mounted() {
    var self = this;
    self.netNewsInfo();
  },
  methods: {
    //获取新闻列表
    netNewsInfo() {
      var self = this;
      let param = {};
      var url =
        "https://issks.com/api/news/index?cate_id=15&page=" + self.pageIndex;

      axios
        .get(url, param)
        .then((res) => {
          const data = res.data.data;
          console.log(data);
          var viewList = [];
          var num = 1;
          for (var i in data.list) {
            var data1 = data.list[i];
            var data2 = data1;
            data2.num = num;
            data2.url = data1.sub_image;
            data2.time = self.timeFormat(data1.updatetime);
            data2.isSet = "";
            viewList.push(data2);
            num++;
          }
          self.newsList = viewList;
          if (data.totalPage > 0) {
            self.pageNum = data.totalPage;
            self.netPageChange();
          }
        })
        .catch((err) => {});
    },
    //时间格式化
    timeFormat(timeDate) {
      var timeNum = new Date(timeDate * 1000);
      let year = timeNum.getFullYear();
      let month = timeNum.getMonth() + 1;
      let date = timeNum.getDate();
      let hours = timeNum.getHours();
      let minute = timeNum.getMinutes();
      let second = timeNum.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minute +
        ":" +
        second
      );
    },
    //鼠标经过
    handleMouseOver(index) {
      var self = this;
      var obj = self.newsList[index];
      obj.isSet = "select";
    },
    outMouseOver(index) {
      var self = this;
      var obj = self.newsList[index];
      obj.isSet = "";
    },
    //处理分页列表
    netPageChange() {
      var self = this;
      var viewList = [];
      for (var i = 1; i <= self.pageNum; i++) {
        var data1 = {};
        if (i == self.pageIndex) {
          data1.isSet = "select";
        } else {
          data1.isSet = "";
        }
        data1.num = i;
        viewList.push(data1);
      }
      self.pageList = viewList;
    },
    //翻页
    setPage(index) {
      var self = this;
      for (var i in self.pageList) {
        if (self.pageList[i].isSet) {
          self.pageList[i].isSet = "";
        }
      }
      var obj = self.pageList[index];
      obj.isSet = "select";
      self.pageIndex = index + 1;
      self.netNewsInfo();
    },
    //上一页下一页
    goFlipping(type) {
      var self = this;
      const num = self.pageIndex;
      if (type == 1) {
        if (self.pageIndex == 1) {
          return;
        }
        //上一页
        const index = num - 2;
        self.setPage(index);
      } else {
        if (self.pageIndex == self.pageNum) {
          return;
        }
        //下一页
        self.setPage(num);
      }
    },
    //跳转新闻详情
    goDetail(index) {
      var self = this;
      var obj = self.newsList[index];
      this.$router.push({ path: "/newDetail", query: { id: obj.id } });
    },
  },
};
</script>

<style>
.swiper-container {
  overflow: visible;
}
.s-swiper {
  width: 100%;
  margin-top: 1.5vw;
}

/* 新闻动态标题区域 */
.news-title-section {
  width: 60%;
  margin: 3vw auto 2vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(to right, transparent, #8aba46, transparent);
}
.title-content {
  padding: 0 3vw;
  text-align: center;
}
.main-title {
  font-size: 2.5vw;
  font-weight: bold;
  color: #333;
}
.sub-title {
  font-size: 1vw;
  color: #8aba46;
  letter-spacing: 0.3vw;
  margin-top: 0.5vw;
}

@media screen and (max-width: 750px) {
  .news-title-section {
    width: 80%;
    margin: 2rem auto 1rem;
  }
  .title-content {
    padding: 0 2rem;
  }
  .main-title {
    font-size: 1.5rem;
  }
  .sub-title {
    font-size: 0.7rem;
    margin-top: 0.3rem;
  }
  .swiper-item {
    width: 100%;
    margin: 0 auto;
  }
  .swiper-cell {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 3rem;
    position: relative;
  }
  .swiper-img {
    width: 100%;
    max-height: 10rem;
    overflow: hidden;
  }
  .swiper-h {
    width: 95%;
    margin: 0 auto;
    background-color: #acacac;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 2.5%;
    bottom: 0;
  }
  .swiper-l {
    margin: 0 1rem;
    padding: 0.5rem;
    background-color: #8aba46;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
  }
  .swiper-r {
    width: 80%;
    height: 1.6rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 1.2rem;
    font-weight: bold;
    color: #fff;
  }
  /* ==================== */
  .s-title {
    width: 80%;
    margin: 2rem auto 0;
  }
  /* ================== */
  .s-ul {
    width: 98%;
    margin: 1rem auto 0;
  }
  .s-li {
    margin-bottom: 2rem;
  }
  .s-cell {
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
  }
  .s-cell.select {
    border: 0.2rem solid #8aba46;
    background-color: #f6f6f6;
  }
  .l-left {
    flex: 1.5;
    margin-right: 2%;
  }
  .l-right {
    flex: 2.5;
    text-align: left;
  }
  .l-h {
    font-size: 0.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: normal;
  }
  .l-h b {
    font-size: 2rem;
  }
  .l-world {
    padding-left: 2rem;
  }
  .l-text {
    text-indent: 1.5rem;
    font-size: 0.7rem;
  }
  .l-btn-box {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.7rem;
  }
  .l-btn-l {
    padding: 0.1rem 1rem;
    background-color: #8aba46;
    border-radius: 4rem;
    color: #fff;
    cursor: pointer;
  }
}
/* =============PC样式============= */
@media screen and (min-width: 755px) {
  .swiper-item {
    width: 90%;
    margin: 0 auto;
  }
  .swiper-cell {
    width: 80%;
    margin: 0 auto;
    padding-bottom: 2vw;
    position: relative;
  }
  .swiper-img {
    width: 85%;
    max-height: 30vw;
    margin: 0 auto;
    overflow: hidden;
  }
  .swiper-img img {
    object-fit: contain;
  }
  .swiper-h {
    width: 70%;
    margin: 0 auto;
    background-color: #666666;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 15%;
    bottom: -1vw;
  }
  .swiper-l {
    margin: 0 1vw;
    padding: 1.5vw 2.6vw;
    background-color: #8aba46;
    font-size: 3vw;
    font-weight: bold;
    color: #fff;
  }
  .swiper-r {
    width: 80%;
    height: 2.2vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 1.3vw;
    font-weight: bold;
    color: #fff;
  }
  /* ==================== */
  .s-title {
    width: 50%;
    margin: 2vw auto 0;
  }
  /* ================== */
  .s-ul {
    width: 75%;
    margin: 3vw auto 0;
  }
  .s-li {
    margin-bottom: 2vw;
  }
  .s-cell {
    padding: 0.5vw;
    display: flex;
    justify-content: space-between;
    border: 0.15vw solid #fff;
    transition: all 0.5s;
  }
  .s-cell.select {
    border: 0.15rem solid #8aba46;
    background-color: #f6f6f6;
    transition: all 0.5s;
    position: relative;
    box-shadow: 2rem 2rem 2.2rem #efefef;
    transform: scale(1.01);
    cursor: pointer;
  }
  .s-cell.select::after {
    position: absolute;
    content: "";
    top: -0.15rem;
    right: -0.15rem;
    width: 0;
    height: 0;
    border-top: 3vw solid #8aba46;
    border-left: 3vw solid transparent;
    transform: rotate(180deg);
  }
  .s-cell.select::before {
    position: absolute;
    content: "";
    top: -0.15rem;
    right: -0.15rem;
    width: 0;
    height: 0;
    border-top: 3vw solid #f6f6f6;
    border-left: 3vw solid transparent;
  }
  .l-left {
    flex: 1;
    margin-right: 5%;
  }
  .l-right {
    flex: 2.5;
    text-align: left;
  }
  .l-h {
    font-size: 1.2vw;
  }
  .l-h b {
    font-size: 4vw;
  }
  .l-world {
    padding-left: 4.7vw;
  }
  .l-text {
    text-indent: 1.5vw;
    font-size: 1vw;
  }
  .l-btn-box {
    margin-top: 0.5vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .l-btn-l {
    padding: 0.1vw 1vw;
    font-size: 1vw;
    background-color: #8aba46;
    border-radius: 4vw;
    color: #fff;
    cursor: pointer;
  }
}

.l-btn-l:hover {
  background-color: orange;
}
.l-btn-r {
  color: #8aba46;
}
/* ==================== */
.page-box {
  width: 80%;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
}
.page-ul {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-cell {
  padding: 0.5rem 0.8rem;
  margin: 0 0.5rem;
  /* border: 0.1rem solid #acacac; */
  background-color: #EEEEEE;
  cursor: pointer;
}
.page-cell.select {
  background-color: #8aba46;
  color: #fff;
}
.page-span {
  cursor: pointer;
}
/* 移动端样式 */
@media screen and (max-width: 750px) {
  .page-box {
    width: 90%;
    font-size: 0.8rem;
  }
  .page-cell {
    padding: 0.2rem 0.5rem;
    margin: 0 0.2rem;
  }
}
</style>
